import constants from "constants";

const {
  LOAD_CLIENT_URLS_SAGA_ADMIN,
  LOAD_CLIENT_URL_SAGA_ADMIN,
  LOAD_CLIENT_URL_WEBINARS_SAGA_ADMIN,
  ADD_CLIENT_URLS_ADMIN,
  ADD_CLIENT_URL_ADMIN,
  ADD_CLIENT_URL_WEBINARS_ADMIN,
  CREATE_CLIENT_URL_SAGA,
  EDIT_CLIENT_URL_SAGA,
  DELETE_CLIENT_URL_SAGA,
  LOAD_CLIENT_URLS_SAGA,
  ADD_CLIENT_URLS,
  SET_TEMP_CLIENT_URL,
  LOAD_CLIENT_WEBINARS_SAGA,
  ADD_CLIENT_WEBINARS,
} = constants;

export const setTempClientUrl = (temp) => ({
  type: SET_TEMP_CLIENT_URL,
  payload: { temp },
});

export const createClientUrlSaga = (client_url) => ({
  type: CREATE_CLIENT_URL_SAGA,
  client_url,
});

export const editClientUrlSaga = (client_url) => ({
  type: EDIT_CLIENT_URL_SAGA,
  client_url,
});

export const deleteClientUrlSaga = (client_url_ids) => ({
  type: DELETE_CLIENT_URL_SAGA,
  client_url_ids,
});

export const loadClientUrlsSagaAdmin = (page = 1, query = {}) => ({
  type: LOAD_CLIENT_URLS_SAGA_ADMIN,
  query,
  page,
});

export const addClientUrlsAdmin = (
  values,
  count,
  page,
  total_pages,
  query = {}
) => ({
  type: ADD_CLIENT_URLS_ADMIN,
  payload: {
    values,
    count,
    page,
    total_pages,
    query,
  },
});

export const loadClientUrlSagaAdmin = (id) => ({
  type: LOAD_CLIENT_URL_SAGA_ADMIN,
  id,
});

export const addClientUrlAdmin = (clientUrl) => ({
  type: ADD_CLIENT_URL_ADMIN,
  payload: { clientUrl },
});

export const loadClientUrlWebinarsSagaAdmin = (id) => ({
  type: LOAD_CLIENT_URL_WEBINARS_SAGA_ADMIN,
  id,
});

export const addClientUrlWebinarsAdmin = (webinars) => ({
  type: ADD_CLIENT_URL_WEBINARS_ADMIN,
  payload: { webinars },
});

export const loadClientUrlsSaga = () => ({
  type: LOAD_CLIENT_URLS_SAGA,
});

export const addClientUrls = (values) => ({
  type: ADD_CLIENT_URLS,
  payload: { values },
});

export const loadClientWebinarsSaga = (scope, slug, page = 1, params = {}) => ({
  type: LOAD_CLIENT_WEBINARS_SAGA,
  scope,
  slug,
  page,
  params,
});

export const addClientWebinars = (type, webinars, count, pages) => ({
  type: ADD_CLIENT_WEBINARS,
  payload: {
    type,
    webinars,
    count,
    pages,
  },
});



// WEBPACK FOOTER //
// ./src/actions/clientUrls.js